import {
  Component,
  OnInit,
  output,
  computed,
  inject,
  signal,
} from '@angular/core';
import { ParameterService } from '@frontend/frontendlib';
import { CountdownTime } from '@frontend/masterdata';
import { interval } from 'rxjs';
import { map, shareReplay, takeWhile, tap } from 'rxjs/operators';

@Component({
  selector: 'app-countdown',
  templateUrl: './countdown.component.html',
  styleUrls: ['./countdown.component.css'],
})
export class CountdownComponent implements OnInit {
  public diffInSeconds = signal(0);
  public ablaufenEvent = output<void>();

  private startDiffInSeconds = computed(() => {
    const dateFrom = new Date(this.parameterService.serverdate ?? '');
    const dateTo = new Date(this.parameterService.payment?.expired_until?.date ?? '');
    return (dateTo.getTime() - dateFrom.getTime()) / 1000;
  });
  
  public currentTimer = signal({
    hoursToDay: 0,
    minutesToDay: 0,
    secondsToDay: 0,
  } as CountdownTime);
  private readonly parameterService = inject(ParameterService);

  ngOnInit(): void {
    this.diffInSeconds.set(this.startDiffInSeconds());
    interval(1000)
      .pipe(
        takeWhile(() => this.diffInSeconds() > 0),
        map(() => this.reduceDiff(1)),
        tap(() => {
          if (this.diffInSeconds() <= 0) {
            this.ablaufenEvent.emit();
          }
        }),
        shareReplay(1)
      )
      .subscribe();
  }

  private reduceDiff(diff: number): void {
    this.diffInSeconds.set(this.diffInSeconds() - diff);
    const _hours = this.diffInSeconds() / 3600;
    const hoursToDay = parseInt(`${_hours}`);
    const _minutes = (this.diffInSeconds() - hoursToDay * 3600) / 60;
    const minutesToDay = parseInt(`${_minutes}`);
    const _seconds =
      this.diffInSeconds() - hoursToDay * 3600 - minutesToDay * 60;
    const secondsToDay = parseInt(`${_seconds}`);
    this.currentTimer.update((prev) => ({
      ...prev,
      hoursToDay,
      minutesToDay,
      secondsToDay,
    }));
  }
}
